// extracted by mini-css-extract-plugin
module.exports = {"CardLabel_container":"CardLabel_CardLabel_container__yscT7","CardLabel_title":"CardLabel_CardLabel_title__JRE43"};